export const formatPhoneNumber = (phoneNumberString: string) => {
    // eslint-disable-next-line require-unicode-regexp
    const cleaned = phoneNumberString.replace(/\D/g, '');
    // eslint-disable-next-line max-len
    // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec, prefer-named-capture-group, require-unicode-regexp
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return `(${match[1]}) ${match[2]} - ${match[3]}`;
    }
    return null;
};
